// Names
export const APP_NAME = "BoxHub";

// Default Values
export const TOOLTIP_DELAY_MS = 500;

// Units
export const MILLIMETRE_UNIT = "mm";
export const KILOMETRE_UNIT = "km";

// GSM

export const GSM = "g/m²";

// Edge Crush

export const EDGE_CRUSH_UNIT = "kN/m";
